import React from 'react';
import styled, { css } from 'styled-components';
import { useObserver } from 'mobx-react-lite';
import { Text } from 'rebass/styled-components';

import { PayByBankLogo } from 'src/assets/pay-by-bank-logo';
import { WhiteLabelLogo } from 'src/payments/components';
import useUser from 'hooks/use-user';
import useUI from 'hooks/use-ui';
import SvgQuestionCircleIcon from 'assets/question-circle-icon';
import useTranslation from 'hooks/use-translation';
import { TextButton } from 'components/core';
import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import { CHECKOUT_PATH } from 'src/payments/constants';

export function CommonLayoutHeader(): JSX.Element {
  const user = useUser();
  const email = useObserver(() => user.email);
  const isLoggedIn = useObserver(() => user.isLoggedIn);
  const UI = useUI();
  const { t } = useTranslation();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const entryPoint = useObserver(() => DutchiePayEnrollment.entryPoint);
  const { useWhiteLabel } = useObserver(() => DutchiePayEnrollment.dispensary);
  const userCameFromCheckout = entryPoint === CHECKOUT_PATH;
  return (
    <>
      <HeaderContainer>
        <HeaderContent>
          {useWhiteLabel ? <WhiteLabelLogo variant='dark' /> : <PayByBankLogo width='105' height='20' />}
          {userCameFromCheckout ? (
            <CancelTextButton variant='secondary' onClick={() => UI.openDutchiePayLeaveModal()}>
              {t('dutchiePayheader.common', 'Cancel')}
            </CancelTextButton>
          ) : (
            <>
              {isLoggedIn ? (
                <Email>{email}</Email>
              ) : (
                <SvgQuestionCircleIcon onClick={() => UI.openDutchiePayLearnMoreModal()} />
              )}
            </>
          )}
        </HeaderContent>
      </HeaderContainer>
      <Spacer />
    </>
  );
}

const Spacer = styled.div`
  height: 52px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 0 ${({ theme }) => theme.colors.grey[90]};
  position: fixed;
  top: 0;
  z-index: 1;
`;

const HeaderContent = styled.div`
  ${({ theme: { spaces } }) => css`
    max-width: var(--dp-content-width);
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    align-items: stretch;
    width: 100%;
    padding: 0 ${spaces[6]};
  `}
`;

const Email = styled(Text)`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey[45]};
`;

const CancelTextButton = styled(TextButton)`
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.grey[45]};
`;
